"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FooterLogo_1 = __importDefault(require("./FooterLogo"));
exports.default = FooterLogo_1.default;
